import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

export const useBookingCodeFromUrl = (): [
  string | undefined,
  (code: string | undefined) => void,
] => {
  const history = useHistory();

  const [bookingCode, setBookingCodeState] = useState<string | undefined>(
    () =>
      new URLSearchParams(window.location.search).get('booking') ?? undefined
  );

  const setBookingCode = useCallback(
    (code: string | undefined) => {
      setBookingCodeState(code);

      const searchParams = new URLSearchParams(history.location.search);

      if (code) {
        searchParams.set('booking', code);
      } else {
        searchParams.delete('booking');
      }

      history.push({
        pathname: history.location.pathname,
        search: searchParams.toString(),
      });
    },
    [history]
  );

  return [bookingCode, setBookingCode];
};
